import axios from "axios";
import { useEffect, useState } from "react";
import { END_POINT } from "../../Redux/AdminReducer/action";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const  loadScript=(src)=>{
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
}

const displayRazorpay=async(data, doctor)=>{
    const res = await loadScript(
        "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
    }

    let orderBody = {
        amount: data?.amount, 
        currency: "INR",
        receipt: data?.receipt
    }

    toast.loading("please wait")
    const result = await axios.post(`${END_POINT}/rpay/order`, orderBody);
    const subscription = await axios.post(`${END_POINT}/rpay/subscription`, data);;
    

    if (!result) {
        alert("Server error. Are you online?");
        return;
    }

    const { amount, id: order_id, currency } = result.data;
    const {id:subscription_id} = subscription?.data||{}

    const options = {
        // key: process?.env?.REACT_APP_KEY_SECRET,
        key:"rzp_test_4Ykylk2imfdH2A",
        // key:"rzp_test_6IkgBmpUNO9nVw",
        "subscription_id": subscription_id,
        amount:amount.toString(),
        currency: currency,
        name: "Soumya Corp.",
        description: "Test Transaction",
        order_id: order_id,
        handler: async function (paymentRes) {
            try {
                const { razorpay_payment_id, razorpay_subscription_id, razorpay_signature } = paymentRes;
                const payload = {
                    razorpay_payment_id,
                    razorpay_subscription_id,
                    razorpay_signature,
                    ...doctor
                };
                const result = await axios.post(`${END_POINT}/rpay/payment-callback`, payload);
                if(result?.data?.status==="success"){
                    window.location.replace("/web/afterAction")
                }
                console.log('Response from server:', result.data);
            } catch (error) {
                console.error('Error sending payment data:', error);
            }
        },
        prefill: {
            name: doctor?.username,
            email: doctor?.email,
            contact: "",
        },
        notes: {
            address: "Soumya Dey Corporate Office",
        },
        theme: {
            color: "#61dafb",
        },
    };

    toast.dismiss()
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
}


const fetchItems = async (path) => {
    try {
      const result = await axios.get(`${END_POINT}/${path}`);
      return result;
    } catch (error) {
      toast.error(error?.response?.data || 'Something went wrong');
      console.log(error);
      toast.error('Something went wrong while fetching data');
    }
  };
  


const PaymentPage=()=>{

const [plans, setplans] = useState([])    
const [section, setsection] = useState('plans')
const [selectedplan, setselectedplan] = useState()
const [doctor, setdoctor] = useState()

 useEffect(()=>{
    fetchItems('rpay/plans').then(res=>{
        console.log(res?.data, 'what is data now')
        setplans(res?.data)
       })
 }, [])

 useEffect(()=>{
    if(selectedplan){
        setsection('register')
    }
 }, [selectedplan])

 useEffect(()=>{
    if(doctor){
        const hasNullOrUndefined = Object.values(doctor).some(d => d === null || d === undefined || d === "");

        console.log(doctor, hasNullOrUndefined)
        if(hasNullOrUndefined){
            toast.info('please fill all details')
            return
        }
        if(doctor?.password !== doctor?.cpassword){
            toast.info('password missmatch')
            return
        }

        setsection('payment')
    }
 }, [doctor])


   return(
    <div className="sectionApp h-full">
        <div className="sections">
        {section==='plans' && <PlanPage plans={plans} setselectedplan={setselectedplan}/>}
        {section==='register' && <SignupPage doctor={doctor} setdoctor={setdoctor}/>}
        {section==='payment' && <OrderPaymentPage selectedplan={selectedplan } doctor={doctor}/>}
        </div>

       {section !== 'plans' &&  <div className="stepper text-center py-3">
<ol class="items-center w-full justify-center space-y-4 sm:flex sm:space-x-8 sm:space-y-0 rtl:space-x-reverse">
    <li class="flex items-center space-x-2.5 rtl:space-x-reverse">
        <button onClick={()=>setsection('plans')} class={`flex items-center  justify-center w-8 h-8 border border-gray-500 rounded-full shrink-0 ${section==='plans' && 'bg-black text-white'}`}>
            1
        </button>
        <span>
            <h3 class="font-medium leading-tight">Plans</h3>
            <p class="text-sm">Select Plan</p>
        </span>
    </li>
    <li class="flex items-center text-gray-500 dark:text-gray-400 space-x-2.5 rtl:space-x-reverse">
    <button onClick={()=>setsection('register')} class={`flex items-center  justify-center w-8 h-8 border border-gray-500 rounded-full shrink-0 ${section==='register' && 'bg-black text-white'}`}>
            2
        </button>
        <span>
            <h3 class="font-medium leading-tight">Doctor Setup</h3>
            <p class="text-sm">create Doctor</p>
        </span>
    </li>
    <li class="flex items-center text-gray-500 dark:text-gray-400 space-x-2.5 rtl:space-x-reverse">
    <button onClick={()=>setsection('payment')} class={`flex items-center  justify-center w-8 h-8 border border-gray-500 rounded-full shrink-0 ${section==='payment' && 'bg-black text-white'}`}>
            3
        </button>
        <span>
            <h3 class="font-medium leading-tight">Payment</h3>
            <p class="text-sm">Proceed Payment</p>
        </span>
    </li>
</ol>
        </div>}


        </div>
   )
}

const PlanPage=({plans, setselectedplan})=>{
 
    console.log('helo')
    const handleSelectedPlan=(item)=>{
        setselectedplan(item)
    }

    return(
        <div class="h-[800px] bg-gray-200  flex flex-wrap items-center  justify-center  ">
            <div class="flex flex-col sm:flex-col lg:flex-row xl:flex-row md:flex-row justify-center items center  container   ">
                {plans?.map((item, pindex)=>{
                    const { name, description, amount } = item;
                    return(
                       name==='advanced' ? (
                        <div class="py-12 sm:py-12 md:py-6 lg:py-6 xl:py-6 px-8 w-full md:max-w-min sm:w-full bg-purple-500 transform scale-1 sm:scale-1 md:scale-105 lg:scale-105 xl:scale-105 z-40  shadow-none sm:shadow-none md:shadow-xl lg:shadow-xl xl:shadow-xl">
                        <h1 class="text-purple-200 font-semibold text-xl ">{name}</h1>
                        <div class="text-center py-4 px-7">
                            <h1 class="text-white text-4xl font-black">{amount/100}</h1>
                            <p class="text-white text-opacity-50 mt-2">Monthely</p>
                            
                        </div>
                        <div class="h-px bg-purple-400"></div>
                        <div class="text-center mt-3">
                            <p class="text-sm text-white text-opacity-80">
                            Advanced Plan
                            </p>
                        </div>
                        <button onClick={()=>setselectedplan(item)} class="w-full mt-6 mb-3 py-2 text-white font-semibold bg-purple-400 hover:shadow-xl duration-200 hover:bg-purple-800">Buy Now</button>
                    </div>
                       ): (
                    <div class="py-12 sm:py-12 md:py-6 lg:py-6 xl:py-6 px-8 w-full md:max-w-min sm:w-full bg-white z-30">
                    <h1 class="text-gray-500 font-semibold text-xl ">{name}</h1>
                        <div class="text-center py-4 px-7">
                            <h1 class="text-gray-700 text-4xl font-black">{amount/100}</h1>
                            <p class="text-gray-500  mt-2">Monthely</p>
                            
                        </div>
                        <div class="h-px bg-gray-200"></div>
                        <div class="text-center mt-3">
                            <p class="text-sm text-gray-400">
                            {description||'description plan'}
                            </p>
                        </div>
                        <button onClick={()=>setselectedplan(item)} class="w-full mt-6 mb-3 py-2 text-white font-semibold bg-gray-700 hover:shadow-xl duration-200 hover:bg-gray-800">Buy Now</button>
                    </div>)
                    )
                })}
           
                
            </div>
             
        </div>
    )
}

const SignupPage=({doctor, setdoctor})=>{
    return(
        <section class="bg-gray-50 dark:bg-gray-900 h-[800px]">

  <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto h-[700px] lg:py-0">
      <a href="#" class="flex items-center mb-6 text-2xl font-semibold text-gray-900 dark:text-white">
          <img class="w-8 h-8 mr-2" src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/logo.svg" alt="logo"/>
          Flowbite    
      </a>
      <div class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                  Create Main Doctor
              </h1>
              <form onSubmit={async e=>{
                e.preventDefault()
               
                let formdata = new FormData(e?.target)
                let email = formdata.get('email')
                let password = formdata.get('password')
                let username = formdata.get('username')
                let cpassword = formdata.get('cpassword')
                let isExist = await fetchItems(`mainDoctor/checkEmail?email=${email}`)

                if(isExist?.data===false){
                    toast.error('Doctor with this Email Already Exist')
                    return 
                }
                setdoctor({email, password, username, cpassword})

              }} class="space-y-4 md:space-y-6" action="#">
                  <div>
                      <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">doctor email</label>
                      <input  type="email" name="email" id="email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="name@company.com" required=""/>
                  </div>
                  <div>
                      <label for="username" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Username</label>
                      <input  type="text" name="username" id="username" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                  <div>
                      <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                      <input  type="password" name="password" id="password" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                  <div>
                      <label for="confirm-password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Confirm password</label>
                      <input type="confirm-password" name="cpassword" id="confirm-password" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required=""/>
                  </div>
                  {/* <div class="flex items-start">
                      <div class="flex items-center h-5">
                        <input id="terms" aria-describedby="terms" type="checkbox" class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800" required=""/>
                      </div>
                      <div class="ml-3 text-sm">
                        <label for="terms" class="font-light text-gray-500 dark:text-gray-300">I accept the <a class="font-medium text-primary-600 hover:underline dark:text-primary-500" href="#">Terms and Conditions</a></label>
                      </div>
                  </div> */}
                  <button type="submit" class="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Create an account</button>
              </form>
          </div>
      </div>
  </div>
</section>
    )
}


const OrderPaymentPage=({selectedplan, doctor})=>{

    let app_order_id = `receipt_order_${new Date().getTime()}`

    const handlePayment=async()=>{
        await displayRazorpay({...selectedplan, receipt:app_order_id}, doctor)
    }
    return(
        <div className="mmain h-[800px] bg-gray-200">
         <div className="max-w-md mx-auto p-5 border rounded-lg shadow-lg relative top-[40%]">
            <h1 className="text-2xl font-bold mb-4">Order Summary {app_order_id}</h1>
            <div className="flex justify-between mb-2">
                <span>{selectedplan.name} x {selectedplan.quantity||1}</span>
                <span>${selectedplan.amount/100}</span>
            </div>
            <div className="flex justify-between font-bold">
                <span>Total:</span>
                <span>${selectedplan.amount/100}</span>
            </div>
            <button
                onClick={handlePayment}
                className="mt-5 w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
            >
                Proceed to Payment
            </button>
        </div>
        </div>
    )
}

export default PaymentPage


// /var/www/shivenclinic/frontend/src